const panelTransitionDurationMs = 275;
const wrapperCls = "c2lw10b4vat";
const transitionWrapperCls = "c2lt12afh6p";
const panelTransitionCls = "c2lp1nlhxai";

export { panelTransitionCls, panelTransitionDurationMs, transitionWrapperCls, wrapperCls };
import "./_create-drawer.style.linaria.module.css";
//# sourceMappingURL=_create-drawer.style.js.map
